export const translations = {
  en: {
    nav: {
      about: 'About',
      services: 'Services',
      process: 'Process',
      gallery: 'Gallery',
      contact: 'Contact Us',
    },
    hero: {
      tagline: 'Built in Africa.',
      tagline2: 'Engineered to European standards.',
      cta: 'Explore Our Solutions',
      subtitle: 'Custom stainless steel fabrication in Lubumbashi, D.R. Congo',
    },
    about: {
      overline: 'About AFRICAINOX',
      title: 'A Strategic Partnership for Industrial Excellence',
      p1: 'AFRICAINOX was born from a strategic partnership between Liberty Group (DRC) and Modern Solution (Dubai), combining local manufacturing capabilities with international expertise.',
      p2: 'Based in Lubumbashi, D.R. Congo, we specialize in custom fabrication of stainless steel equipment and structures, delivering European-quality solutions with the advantage of local production.',
      p3: 'Our mission is clear: provide faster delivery, customized solutions, cost optimization, and local after-sales support — a compelling alternative to costly imports.',
      stat1_num: '2',
      stat1_label: 'Strategic Partners',
      stat2_num: '4',
      stat2_label: 'Industry Sectors',
      stat3_num: '100%',
      stat3_label: 'Custom Solutions',
    },
    services: {
      overline: 'Our Sectors',
      title: 'Industries We Serve',
      mining: {
        title: 'Mining Industry',
        desc: 'Corrosion-resistant equipment and technical structures designed for the demanding conditions of mining operations across Central and Southern Africa.',
      },
      horeca: {
        title: 'Hospitality & F&B',
        desc: 'Professional kitchen equipment, stainless steel furniture, counters, and custom solutions for hotels, restaurants, and catering services.',
      },
      healthcare: {
        title: 'Healthcare',
        desc: 'Stainless steel equipment and hygienic solutions meeting strict standards for hospitals, clinics, and medical facilities.',
      },
      construction: {
        title: 'Construction & Architecture',
        desc: 'Railings, structures, and custom stainless steel elements for modern architectural projects and commercial buildings.',
      },
    },
    process: {
      overline: 'Our Process',
      title: 'Precision at Every Step',
      step1: { title: 'Cutting', desc: 'Precision cutting of stainless steel sheets and profiles using advanced industrial equipment.' },
      step2: { title: 'Bending', desc: 'Expert metal bending and forming to achieve exact specifications and complex shapes.' },
      step3: { title: 'Fabrication & Welding', desc: 'Professional TIG and MIG welding by certified technicians ensuring structural integrity.' },
      step4: { title: 'Finishing & QC', desc: 'Surface finishing, polishing, and rigorous quality control to European standards.' },
    },
    gallery: {
      overline: 'Our Work',
      title: 'Project Gallery',
      subtitle: 'A selection of our custom stainless steel fabrication projects across multiple sectors.',
    },
    contact: {
      overline: 'Get in Touch',
      title: 'Contact Us',
      subtitle: 'Ready to discuss your project? Reach out to our team in Lubumbashi.',
      name: 'Full Name',
      email: 'Email Address',
      company: 'Company Name',
      phone: 'Phone Number',
      message: 'Your Message',
      submit: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully! We will get back to you soon.',
      error: 'Failed to send message. Please try again.',
      address: 'Lubumbashi, D.R. Congo',
      website: 'www.africainox.com',
    },
    footer: {
      tagline: 'Custom-made stainless steel solutions manufactured in Congo with European expertise and quality standards.',
      quickLinks: 'Quick Links',
      sectors: 'Sectors',
      contactInfo: 'Contact',
      rights: 'All rights reserved.',
    },
  },
  fr: {
    nav: {
      about: 'A Propos',
      services: 'Services',
      process: 'Processus',
      gallery: 'Galerie',
      contact: 'Contactez-nous',
    },
    hero: {
      tagline: 'Fabrique en Afrique.',
      tagline2: 'Qualite europeenne.',
      cta: 'Decouvrir Nos Solutions',
      subtitle: 'Fabrication sur mesure en acier inoxydable a Lubumbashi, R.D. Congo',
    },
    about: {
      overline: 'A Propos d\'AFRICAINOX',
      title: 'Un Partenariat Strategique pour l\'Excellence Industrielle',
      p1: 'AFRICAINOX est ne d\'un partenariat strategique entre Liberty Group (RDC) et Modern Solution (Dubai), combinant les capacites de fabrication locales avec l\'expertise internationale.',
      p2: 'Base a Lubumbashi, R.D. Congo, nous sommes specialises dans la fabrication sur mesure d\'equipements et de structures en acier inoxydable, offrant des solutions de qualite europeenne avec l\'avantage de la production locale.',
      p3: 'Notre mission est claire : offrir une livraison plus rapide, des solutions personnalisees, une optimisation des couts et un support apres-vente local — une alternative convaincante aux importations couteuses.',
      stat1_num: '2',
      stat1_label: 'Partenaires Strategiques',
      stat2_num: '4',
      stat2_label: 'Secteurs Industriels',
      stat3_num: '100%',
      stat3_label: 'Solutions Sur Mesure',
    },
    services: {
      overline: 'Nos Secteurs',
      title: 'Industries que Nous Servons',
      mining: {
        title: 'Industrie Miniere',
        desc: 'Equipements resistant a la corrosion et structures techniques concues pour les conditions exigeantes des operations minieres en Afrique centrale et australe.',
      },
      horeca: {
        title: 'Hotellerie & Restauration',
        desc: 'Equipements de cuisine professionnelle, mobilier en acier inoxydable, comptoirs et solutions sur mesure pour hotels, restaurants et services de restauration.',
      },
      healthcare: {
        title: 'Sante',
        desc: 'Equipements en acier inoxydable et solutions hygieniques repondant aux normes strictes pour hopitaux, cliniques et etablissements medicaux.',
      },
      construction: {
        title: 'Construction & Architecture',
        desc: 'Garde-corps, structures et elements sur mesure en acier inoxydable pour projets architecturaux modernes et batiments commerciaux.',
      },
    },
    process: {
      overline: 'Notre Processus',
      title: 'Precision a Chaque Etape',
      step1: { title: 'Decoupe', desc: 'Decoupe de precision des toles et profiles en acier inoxydable avec equipements industriels avances.' },
      step2: { title: 'Pliage', desc: 'Pliage et formage expert du metal pour atteindre des specifications exactes et des formes complexes.' },
      step3: { title: 'Fabrication & Soudure', desc: 'Soudure TIG et MIG professionnelle par techniciens certifies assurant l\'integrite structurelle.' },
      step4: { title: 'Finition & CQ', desc: 'Finition de surface, polissage et controle qualite rigoureux selon les normes europeennes.' },
    },
    gallery: {
      overline: 'Nos Realisations',
      title: 'Galerie de Projets',
      subtitle: 'Une selection de nos projets de fabrication sur mesure en acier inoxydable dans plusieurs secteurs.',
    },
    contact: {
      overline: 'Contactez-nous',
      title: 'Nous Contacter',
      subtitle: 'Pret a discuter de votre projet ? Contactez notre equipe a Lubumbashi.',
      name: 'Nom Complet',
      email: 'Adresse Email',
      company: 'Nom de l\'Entreprise',
      phone: 'Numero de Telephone',
      message: 'Votre Message',
      submit: 'Envoyer le Message',
      sending: 'Envoi en cours...',
      success: 'Message envoye avec succes ! Nous vous recontacterons bientot.',
      error: 'Echec de l\'envoi. Veuillez reessayer.',
      address: 'Lubumbashi, R.D. Congo',
      website: 'www.africainox.com',
    },
    footer: {
      tagline: 'Solutions sur mesure en acier inoxydable fabriquees au Congo avec expertise et normes de qualite europeennes.',
      quickLinks: 'Liens Rapides',
      sectors: 'Secteurs',
      contactInfo: 'Contact',
      rights: 'Tous droits reserves.',
    },
  },
};
